// extracted by mini-css-extract-plugin
export var checked = "footer-landing-page-module--checked--ec6c4";
export var footer = "footer-landing-page-module--footer--4b330";
export var footerBottomSection = "footer-landing-page-module--footer-bottomSection--7bf4d";
export var footerLogoContainer = "footer-landing-page-module--footer-logoContainer--fe361";
export var footerNumeroVerdeContainer = "footer-landing-page-module--footer-NumeroVerdeContainer--1aa72";
export var footerNumeroVerdeText = "footer-landing-page-module--footer-NumeroVerdeText--afcc3";
export var footerNumeroVerdeTextContainer = "footer-landing-page-module--footer-NumeroVerdeTextContainer--98dec";
export var footerSocialsLinksContainer = "footer-landing-page-module--footer-socialsLinksContainer--992d1";
export var footerTopSection = "footer-landing-page-module--footer-topSection--2974a";
export var unchecked = "footer-landing-page-module--unchecked--0be4f";